// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

import { EventBus } from './services/EventBus.js'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import HttpMixin from '@/mixins/http-mixin.vue'

Vue.mixin(HttpMixin)

// Sync store with router
sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
var app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Add a request interceptor
Vue.prototype.$http.interceptors.request.use(function (config) {
  app.$Progress.start()
  // Do something before request is sent
  return config
}, function (error) {
  app.$Progress.fail()
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
Vue.prototype.$http.interceptors.response.use(function (response) {
  // Do something with response data
  app.$Progress.finish()
  return response
}, function (error) {
  // Do something with response error
  app.$Progress.fail()
  return Promise.reject(error)
})

window.addEventListener('unhandledrejection', event => {
  // Can prevent error output on the console:
  event.preventDefault()

  var promise = event.promise

  promise.catch((error) => {
    EventBus.$emit('serverError', { component: app, error: error })
  })
})
